import React, { FC } from 'react';
import { CheckboxInputProps } from 'shared/components/COCheckbox';
import {
  useFormContext,
  Controller,
  ControllerRenderProps,
  FieldValues,
} from 'react-hook-form';
import { Checkbox, Col, Row } from 'antd';
import styles from './rhfCheckbox.module.scss';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

const RHFCheckbox: FC<CheckboxInputProps> = props => {
  const { name, label, disabled, onChange } = props;
  const { control } = useFormContext();

  const handleOnChange =
    (field: ControllerRenderProps<FieldValues, string>) =>
    (e: CheckboxChangeEvent) => {
      field.onChange(e?.target?.checked);
      onChange?.(e);
    };

  return (
    <Controller
      name={name ?? ''}
      control={control}
      render={({ field }) => (
        <Row className={styles.checkboxContainer}>
          <Checkbox
            {...field}
            disabled={disabled}
            onChange={handleOnChange(field)}
            checked={Boolean(field.value)}>
            {label}
          </Checkbox>
        </Row>
      )}
    />
  );
};

export default RHFCheckbox;
